/**
 * Languages available for transcription (ISO 639-1).
 * Intentionally separate from report-translation list — no regional duplicates.
 */

export const TRANSCRIPTION_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Spanish' },
  { code: 'fr', name: 'French' },
  { code: 'it', name: 'Italian' },
  { code: 'de', name: 'German' },
  { code: 'pt', name: 'Portuguese' },
  { code: 'ar', name: 'Arabic' },
  { code: 'zh', name: 'Chinese' },
  { code: 'ja', name: 'Japanese' },
  { code: 'ko', name: 'Korean' },
  { code: 'ru', name: 'Russian' },
  { code: 'tr', name: 'Turkish' },
  { code: 'nl', name: 'Dutch' },
  { code: 'pl', name: 'Polish' },
  { code: 'sv', name: 'Swedish' },
  { code: 'sr', name: 'Serbian' },
];

export const DEFAULT_TRANSCRIPTION_LANGUAGE = 'en';

const LEGACY_LANGUAGE_NAMES = {
  hr: 'Serbian',
  bs: 'Serbian',
};

export function getTranscriptionLanguageName(code) {
  if (!code) return 'English';
  if (LEGACY_LANGUAGE_NAMES[code]) return LEGACY_LANGUAGE_NAMES[code];
  const match = TRANSCRIPTION_LANGUAGES.find((l) => l.code === code);
  return match?.name || code.toUpperCase();
}
